import {
  Box,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FixedSizeList as List, areEqual } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import AutoSizer from "react-virtualized-auto-sizer";
import dayjs from "dayjs";
import { setPGState } from "../productGroupSetupSlice";

export default function CreateEditIndividualSKUDate({ tempSKUs, setTempSKUs, loadMore }) {
  const dispatch = useDispatch();
  const { selectedSKUs, createFromDate, createToDate } = useSelector((store) => store.productGroupSetup);

  const minDate = dayjs().add(1, "day");
  const [searchedPGName, setsearchedPGName] = useState("");

  const filteredSKUs = useMemo(() => {
    return searchedPGName
      ? tempSKUs.filter((sku) => sku.productName.toLowerCase().includes(searchedPGName.toLowerCase()))
      : tempSKUs;
  }, [searchedPGName, tempSKUs]);

  useEffect(() => {
    const selSKUs = selectedSKUs.map((item) =>
      item.effectiveStartDate && item.effectiveEndDate
        ? item
        : { ...item, effectiveStartDate: createFromDate, effectiveEndDate: createToDate }
    );
    dispatch(setPGState("selectedSKUs", selSKUs));
  }, []);

  const updateFromDate = useCallback((newDate, productName) => {
    setTempSKUs((prev) =>
      prev.map((item) =>
        item.productName === productName ? { ...item, effectiveStartDate: newDate } : item
      )
    );
  }, []);

  const updateToDate = useCallback((newDate, productName) => {
    setTempSKUs((prev) =>
      prev.map((item) =>
        item.productName === productName ? { ...item, effectiveEndDate: newDate } : item
      )
    );
  }, []);

  const Row = React.memo(({ index, style, data }) => {
    const sku = data[index];
    if (!sku) return null;

    return (
      <div style={{ ...style, display: "flex", alignItems: "center", padding: "5px 10px" }}>
        <Grid container columnSpacing={1} alignItems="center">
          <Grid item xs={8}>
            <Typography variant="body1">{sku.productName}</Typography>
          </Grid>
          <Grid item xs={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                minDate={minDate}
                label="From"
                value={dayjs(sku.effectiveStartDate)}
                format="DD/MM/YYYY"
                onChange={(newDate) => updateFromDate(newDate, sku.productName)}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                minDate={minDate}
                label="To"
                value={dayjs(sku.effectiveEndDate)}
                format="DD/MM/YYYY"
                onChange={(newDate) => updateToDate(newDate, sku.productName)}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </div>
    );
  }, areEqual);

  // const isItemLoaded = (index) => index < filteredSKUs.length;
  // const loadMoreItems = isItemLoaded ? () => {} : loadMore;
  const isItemLoaded = (index) =>  !!filteredSKUs[index];
   const loadMoreItems = loadMore;

  return (
    <Box sx={{ mt: 4 }}>
      <Grid item sm={7.5} md={8.7} lg={9}>
        <TextField
          label="Search"
          variant="outlined"
          size="small"
          fullWidth
          sx={{ mb: 2 }}
          onChange={(e) => setsearchedPGName(e.target.value)}
          value={searchedPGName}
          InputProps={{ autoComplete: "off" }}
        />
      </Grid>
      <Box sx={{ bgcolor: "grey.lighter", height: 40, pl: 1, pt: 1, borderRadius: 1 }}>
        <Typography sx={{ fontWeight: "bold", color: "darkred.light" }}>SKUs</Typography>
      </Box>
      <Box sx={{ height: 320, overflow: "auto" }}>
        <AutoSizer>
          {({ height, width }) => (
            <InfiniteLoader
              isItemLoaded={isItemLoaded}
              itemCount={filteredSKUs.length + 20}
              loadMoreItems={loadMoreItems}
            >
              {({ onItemsRendered, ref }) => (
                <List
                  height={height}
                  width={width}
                  itemCount={filteredSKUs.length}
                  itemSize={60}
                  itemKey={(index) => filteredSKUs[index]?.productName || index}
                  itemData={filteredSKUs}
                  outerElementType="div"
                  onItemsRendered={onItemsRendered}
                  ref={ref}
                >
                  {Row}
                </List>
              )}
            </InfiniteLoader>
          )}
        </AutoSizer>
      </Box>
    </Box>
  );
}